module.exports = __webpack_public_path__ + "static/media/member-guide4.76627958.png";